




import { Component, Vue } from 'vue-property-decorator';
import { KycRequests } from '@/api';
import ApiCancelError from '@/resources/error/ApiCancelError';
import ApiModalError from '@/resources/error/ApiModalError';

@Component
export default class Page extends Vue {
  public async created(): Promise<void> {
    try {
      const kycRequestId: number = this.$store.getters['auth/kycRequestID'];
      await KycRequests.confirm(kycRequestId);
      this.$store.commit('completion/setComplete');
    } catch (error) {
      if (error instanceof ApiCancelError) {
        // キャンセルは握りつぶす
      } else if (error instanceof ApiModalError) {
        // clientRetryableで処理したエラーは握りつぶす
      } else throw error;
    }
  }
}
